import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { DirSaleLineProgProdList } from '@/sc/entities/dirSaleLine/DirSaleLineProgProdList';

export const DirSaleLineDetail = () => {
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    {
      id: 'progProd',
      label: 'Program Products',
      content: <DirSaleLineProgProdList dirSaleLineId={entityObj.id} />,
    },
    {
      id: 'valTab',
      label: 'Validations',
      content: <ValList parentEntity="DIR_SALE_LINE" parentEntityId={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
